export const common = {
  // Navigation
  'nav.features': 'Funktioner',
  'nav.howItWorks': 'Hur det fungerar',
  'nav.pricing': 'Priser',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Om oss',
  'nav.getStarted': 'Kom igång',

  // About Us Section
  'aboutUs.badge': "Om oss",
  'aboutUs.title': "Varför IdeaVerdict finns",
  'aboutUs.line1': "Vem som helst kan ha en idé.",
  'aboutUs.line2': "Få erkänner att deras inte håller.",
  'aboutUs.paragraph1':
    "De flesta idéer misslyckas inte för att grundarna saknade mod. De misslyckas för att ingen sa sanningen i tid. IdeaVerdict täpper till det glappet — vi ger dig den brutala läsningen dina vänner inte gör.",
  'aboutUs.belief1a': "Vi handlar inte med hype.",
  'aboutUs.belief1b': "Vi handlar med marknadssignaler.",
  'aboutUs.belief2a': "Vi säljer inte motivation.",
  'aboutUs.belief2b': "Vi säljer en tydlig läsning av efterfrågan, konkurrens och genomförbarhet.",
  'aboutUs.mission1': "Vårt jobb är inte att få din idé att se bra ut.",
  'aboutUs.mission2': "Vårt jobb är att säga om den är det.",
  'aboutUs.analysis':
    "IdeaVerdict bedömer idéer på det som spelar roll — marknadsstruktur, verklig efterfrågan, konkurrens, kapitalbehov, tid till intäkt, skalbarhet. Ingen känsla. Ingen optimism. Bara analys.",
  'aboutUs.failure1': "De flesta företag misslyckas.",
  'aboutUs.failure2': "Inte för att människorna bakom dem var inkompetenta —",
  'aboutUs.failure3': "utan för att ingen pressade tillbaka tillräckligt hårt, tillräckligt tidigt.",
  'aboutUs.clarity': "Vi finns för att pressa tillbaka.",
  'aboutUs.value1': "Direkt.",
  'aboutUs.value2': "Ärligt.",
  'aboutUs.value3': "Snabbt.",
  'aboutUs.confirm': "Om din idé har substans backar vi den.",
  'aboutUs.deny': "Om den inte har det säger vi det rakt i ansiktet.",
  'aboutUs.noApplause': "Inga applåder.",
  'aboutUs.noSugarcoating': "Inget sockerlim.",
  'aboutUs.noTheater': "Ingen teater.",
  'aboutUs.noHype': "Bara domen.",
  // Hero Section
  'hero.badge': 'AI-dom på under 60 sekunder',
  'hero.title1': 'Bygg inte',
  'hero.title2': 'innan du kollar.',
  'hero.subtitle': 'IdeaVerdict pressar din idé som en skeptisk VC.',
  'hero.subtitleLine2': 'Ärlig dom på sekunder — ingen hype, inget smicker.',
  'hero.cta': 'Få min dom',
  'hero.ctaSecondary': 'Så funkar det',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Credits per förfrågan',
  'hero.stat2Value': 'Från 7',
  'hero.stat2Label': 'Bedömningsdimensioner',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Ärlig & Privat',

  // Features Section
  'features.title1': 'Byggt för',
  'features.title2': 'grundare som',
  'features.title3': 'vill ha sanningen',
  'features.bullet1.title': 'Ärligt utlåtande på sekunder',
  'features.bullet1.description':
    'Stark, Blandad eller Svag — med resonemanget bakom. Inga applåder, ingen försköning, ingen teater.',
  'features.bullet2.title': 'Bedömd på det som spelar roll',
  'features.bullet2.description':
    'Din idé betygsätts på verklig efterfrågan, konkurrens, kapitalbehov, tid till intäkt och skalbarhet — inte på vibbar.',
  'features.bullet3.title': 'Från utlåtande till bygge',
  'features.bullet3.description':
    'Builder-läget förvandlar en godkänd idé till en utvecklarbrief: användarflöden, kärnfunktioner, tekniska anteckningar.',

  // How It Works
  'howItWorks.title': 'Hur det fungerar',
  'howItWorks.subtitle': 'Fyra steg till klarhet om din affärsnisch.',
  'howItWorks.step1Title': 'Välj en plan',
  'howItWorks.step1Desc': 'Starter, Pro eller Builder – beroende på djupet av din granskning.',
  'howItWorks.step2Title': 'Fråga AI',
  'howItWorks.step2Desc': 'Ställ dina frågor om nischen. Varje förfrågan kostar 30 credits.',
  'howItWorks.step3Title': 'Få ärlig dom',
  'howItWorks.step3Desc': 'AI betygsätter: Bra, Genomsnittlig eller Dålig. Inget omsvep.',
  'howItWorks.step4Title': 'Fatta ett beslut',
  'howItWorks.step4Desc': 'Nu vet du om det är värt att gå vidare.',

  // Pricing
  'pricing.title': 'Priser',
  'pricing.subtitle': 'Välj den plan som passar ditt granskningsdjup.',
  'pricing.monthly': 'Månadsvis',
  'pricing.yearly': 'Årsvis',
  'pricing.yearlyDiscount': 'Årsprenumeration:',
  'pricing.yearlyDiscountValue': '-20% rabatt',
  'pricing.perMonth': 'per månad',
  'pricing.selectPlan': 'Välj plan',
  'pricing.mostPopular': 'Mest populära',
  'pricing.footer':
    'Alla priser i CHF. Credits dras endast för lyckade AI-svar.',

  
  // Pricing Features
  'pricing.feature1': 'Gratis chatt (inget formulär)',
  'pricing.feature2': 'Marknadslogik & ärlig bedömning',
  'pricing.feature3': 'Beständig chatthistorik',
  'pricing.feature4': 'Flera parallella chattsessioner',
  'pricing.feature5': 'Helt flerspråkig',
  'pricing.feature6': 'Kreditbaserad användning',
  'pricing.feature7': 'Månatlig återställning',
  'pricing.feature8': 'Marknadsanalys',
  'pricing.feature9': 'Sammanfattning',
  'pricing.feature10': 'Styrkor',
  'pricing.feature11': 'Svagheter',
  'pricing.feature12': 'Möjligheter',
  'pricing.feature13': 'Risker',
  'pricing.feature14': 'Rekommendationer',
  'pricing.feature15': 'Ladda ner PDF',
  'pricing.feature16': 'Inga utvecklarbriefingar',
  'pricing.feature17': 'Byggarläge: Utvecklarbriefingar',
  'pricing.feature18': 'Strukturerad sammanfattning',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Tillgång till AI-nischchattbot',
  'pricing.starter.credits': '2 500 credits per månad',
  'pricing.starter.feature1': 'Generera nischidé',
  'pricing.starter.feature2': 'Förfina nisch',
  'pricing.starter.feature3': 'Marknadsrealitetskontroll',
  'pricing.starter.feature4': 'Konkurrensbedömning',
  'pricing.starter.feature5': 'Tidsbedömning',
  'pricing.starter.feature6': 'Ärlig dom',
  'pricing.starter.feature7': 'Privata sessioner',
  'pricing.starter.feature8': 'Historik & export',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Tillgång till AI-nischchattbot',
  'pricing.pro.credits': '5 000 credits per månad',
  'pricing.pro.feature1': 'Alla Starter-funktioner',
  'pricing.pro.feature2': 'Fler credits för intensiv granskning',
  'pricing.pro.feature3': 'Förbättringsförslag',
  'pricing.pro.feature4': 'Alternativa nischer',
  'pricing.pro.feature5': 'Detaljerad marknadsanalys',
  'pricing.pro.feature6': 'Prioriterad support',
  'pricing.pro.feature7': 'Avancerade filter',
  'pricing.pro.feature8': 'Sessionfavoriter',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Alla funktioner + Builder-läge",
  'pricing.builder.credits': "10 000 credits per månad",
  'pricing.builder.feature1': 'Alla Pro-funktioner',
  'pricing.builder.feature2': 'Obegränsade AI-förfrågningar',
  'pricing.builder.feature3': 'Builder-läge: Utvecklarbriefingar',
  'pricing.builder.feature4': 'Strukturerad projektöversikt',
  'pricing.builder.feature5': 'Användarflöden & kärnfunktioner',
  'pricing.builder.feature6': 'Tekniska anteckningar',
  'pricing.builder.feature7': 'Definiera icke-mål',
  'pricing.builder.feature8': 'Skälig användningsgräns',
  'pricing.builder.limitNote': 'Skälig användningsgräns',
  'pricing.monthlyReset': 'Återställs månadsvis',

  // Modal
  'pricing.modal.selected': 'vald',
  'pricing.modal.comingSoon':
    'Registrering och betalningshantering kommer att finnas tillgängligt snart.',
  'pricing.modal.patience':
    'Vi arbetar för att ge dig en säker och sömlös upplevelse. Var vänlig ha tålamod.',
  'pricing.modal.understood': 'Förstått',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Besvarat ärligt & kritiskt.',
  'faq.q1': "Vad gör IdeaVerdict egentligen?",
  'faq.a1': "Den bedömer din affärsidé på det som avgör utfall — verklig efterfrågan, konkurrens, kapitalbehov, time-to-market och skalbarhet.\nOm idén håller visar vi hur du skärper den.\nOm den inte gör det säger vi också det.",
  'faq.q2': "Genererar ni också idéer?",
  'faq.a2': "Ja — men inga slumpvisa förslag ur en hatt.\nIdéer kommer från verkliga marknadsluckor, inte från det som trendar denna vecka.",
  'faq.q3': "Förbättrar ni befintliga affärsmodeller?",
  'faq.a3': "Ja, om det finns något att förbättra.\nVi polerar inte trasiga idéer — vi stärker de som redan har en bas.",
  'faq.q4': "Hur skiljer ni er från andra AI-verktyg?",
  'faq.a4': "De flesta AI-verktyg säger att din idé är fantastisk.\nVi säger om den faktiskt är det.\nSkillnaden: realism istället för entusiasm.",
  'faq.q5': "Garanterar detta framgång?",
  'faq.a5': "Nej.\nVi hjälper dig undvika dåliga vad — risken försvinner inte, men du går in med öppna ögon.",
  'faq.q6': "Vem är IdeaVerdict till för?",
  'faq.a6': "Grundare före lansering.\nBuilders före helgens sidoprojekt.\nOperatörer före nästa vad.\nInvesterare före signaturen.\n\nFör alla som vill ha klarhet före åtagande.",
  'faq.q7': "Vad om jag bara vill ha validering?",
  'faq.a7': "Då är IdeaVerdict fel verktyg.\nVi levererar en ärlig läsning, inte tröst.",
  'faq.q8': "Hur ärlig är analysen verkligen?",
  'faq.a8': "Så ärlig som datan tillåter.\nVi mjukar inte upp en svag dom för att skona känslor.",
  'faq.q9': "Ersätter detta riktig marknadsundersökning?",
  'faq.a9': "Nej.\nDet är en snabb strategisk koll innan du investerar — inte en 50-sidig marknadsstudie.",
  'faq.q10': "Varför så direkt?",
  'faq.a10': "För att bygga fel sak kostar månader.\nEn ärlig dom kostar minuter.\n\nVi väljer minuterna.",
  // Footer
  'footer.description':
    'IdeaVerdict finns inte för att få dig att må bra. Det finns för att hjälpa dig välja rätt.',
  'footer.product': 'Produkt',
  'footer.aiAssistant': 'AI-assistent',
  'footer.howItWorks': 'Hur det fungerar',
  'footer.pricing': 'Priser',
  'footer.faq': 'FAQ',
  'footer.legal': 'Juridiskt',
  'footer.privacy': 'Integritet',
  'footer.terms': 'Villkor',
  'footer.imprint': 'Impressum',
  'footer.support': 'Support',
  'footer.contact': 'Kontakt',
  'footer.documentation': 'Dokumentation',
  'footer.copyright': '© 2026 IdeaVerdict. Alla rättigheter förbehållna.',

  // AI Assistant
  'aiAssistant.title': 'AI-nischassistent',
  'aiAssistant.subtitle': 'Fråga om nischer',
  'aiAssistant.welcomeMessage':
    'Hej! Beskriv din idé eller fråga mig om en nisch. Jag ger dig en tydlig och ärlig utvärdering.',
  'aiAssistant.demoResponse':
    'Detta är en demo. För att få riktiga AI-utvärderingar, vänligen registrera dig och välj en plan.',
  'aiAssistant.placeholder': 'Beskriv din idé...',

  // Header & Sidebar
  'dashboard.header.title': 'Instrumentpanel',
  'dashboard.header.aiAssistant': 'Din AI-assistent',
  'header.logout': 'Logga ut',
  'dashboard.sidebar.overview': 'Översikt',
  'dashboard.sidebar.aiChat': 'AI-assistent',
  'dashboard.sidebar.newAnalysis': 'AI-assistent',
  'dashboard.sidebar.history': 'Historik',
  'dashboard.sidebar.credits': 'Credits',
  'dashboard.sidebar.settings': 'Inställningar',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Välkommen tillbaka, {{name}}',
  'dashboard.overview.subtitle':
    'Här är en snabb översikt över din aktivitet',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Credits kvar',
  'dashboard.stats.totalAnalyses': 'Totalt antal analyser',
  'dashboard.stats.goodRatings': 'Positiva betyg',
  'dashboard.stats.nextReset': 'Nästa återställning om',
  'dashboard.stats.days': 'dagar',

  // Quick Actions
  'dashboard.quickActions.title': 'Snabba åtgärder',
  'dashboard.quickActions.checkNewIdea': 'Kontrollera en idé',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Analysera en befintlig affärsidé',
  'dashboard.quickActions.generateIdea': 'Generera en idé',
  'dashboard.quickActions.generateIdeaDesc':
    'Hitta en ny lönsam nisch',
  'dashboard.quickActions.builderBriefing': 'Builder-briefing',
  'dashboard.quickActions.builderBriefingDesc':
    'Förvandla en idé till en utvecklarklar briefing',
  'dashboard.quickActions.premiumOnly': 'Endast Builder',

  // Chat Header
  'chat.title': 'AI-nischassistent',
  'chat.subtitle':
    'Ställ frågor om nischer. Jag utvärderar kritiskt och ärligt.',
  'chat.creditsLabel': 'Credits',

  // Chat Welcome
  'chat.welcomeTitle': 'Välkommen till AI-nischassistenten',
  'chat.welcomeDesc':
    'Beskriv din idé eller fråga om en nisch. Jag kommer att utvärdera den ärligt: Bra, Genomsnittlig eller Dålig.',
  'chat.aiWelcome':
    'Hej! Beskriv din idé eller fråga mig om en nisch. Jag ger dig en tydlig och ärlig utvärdering.',

  // Chat Suggestions
  'chat.suggestion1': 'Jag vill bygga ett SaaS-verktyg för frilansare att hantera fakturor. Är detta en bra nisch?',
  'chat.suggestion2': 'Hitta ett online-företag med låg konkurrens jag kan starta med $500 utan programmeringskunskaper.',
  'chat.suggestion3': 'Utvärdera detta: en AI-driven måltidsplaneringsapp för upptagna föräldrar med kostbegränsningar.',
  'chat.suggestion4': 'Jag vill sälja digitala mallar på Etsy för småföretagare. Analysera denna nisch ärligt.',

  // Chat Actions
  'chat.newConversation': 'Ny konversation',
  'chat.today': 'Idag',
  'chat.yesterday': 'Igår',
  'chat.thisWeek': 'Denna vecka',
  'chat.thisMonth': 'Denna månad',
  'chat.older': 'Äldre',
  'chat.messages': 'meddelanden',
  'chat.renameConversation': 'Byt namn',
  'chat.deleteConversation': 'Radera',
  'chat.cancel': 'Avbryt',
  'chat.rename': 'Byt namn',
  'chat.delete': 'Radera',
  'chat.favorite': 'Lägg till i favoriter',
  'chat.unfavorite': 'Ta bort från favoriter',
  'chat.searchSessions': 'Sök konversationer...',
  'chat.noResults': 'Inga resultat hittades',
  'chat.noSessions': 'Inga konversationer ännu',
  'chat.enterNewName': 'Ange nytt namn...',
  'chat.deleteConfirmMessage':
    'Är du säker på att du vill radera denna konversation? Denna åtgärd kan inte ångras.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Skriv din fråga… (kostar 30 credits)',
  'chat.send': 'Skicka',
  'chat.voice': 'Tala',
  'chat.listeningPlaceholder': 'Jag lyssnar... Tala nu.',
  'chat.stopListening': 'Sluta lyssna',
  'chat.recording': 'Inspelning...',
  'chat.speechNotSupported': 'Din webbläsare stöder inte röstigenkänning.',
  'chat.microphonePermissionDenied': 'Mikrofonåtkomst nekad. Tillåt åtkomst i webbläsarinställningarna.',
  'chat.errorNotEnoughCredits':
    'Inte tillräckligt med credits. Uppgradera din plan eller vänta på nästa återställning.',
  'chat.errorAiFailed': 'AI-svar misslyckades. Inga credits drogs.',
  'chat.errorRateLimit': 'För många förfrågningar. Vänta en stund.',

  // Ratings
  'rating.good': 'Bra',
  'rating.medium': 'Genomsnittlig',
  'rating.bad': 'Dålig',

  // Auth Page
  'auth.branding.headline1': 'Inte varje idé är bra.',
  'auth.branding.headline2': 'Vi säger det ärligt.',
  'auth.branding.subtitle':
    'En besluts-AI för affärsnischer. Tydlig. Kritisk. Inget omsvep.',
  'auth.benefits.privacy.title': '100% Privat',
  'auth.benefits.privacy.desc':
    'Dina idéer förblir helt privata och säkra.',
  'auth.benefits.honest.title': 'Ärlig AI',
  'auth.benefits.honest.desc':
    'Inget omsvep – bara tydlig, kritisk feedback.',
  'auth.benefits.fast.title': 'Snabba resultat',
  'auth.benefits.fast.desc': 'Få klarhet om din nisch på några minuter.',
  'auth.trust.users': 'Aktiva användare',
  'auth.trust.ideas': 'Idéer analyserade',
  'auth.trust.rating': 'Användarbetyg',
  'auth.login.title': 'Logga in',
  'auth.login.headline': 'Välkommen tillbaka',
  'auth.login.subtitle': 'Logga in för att fortsätta din resa.',
  'auth.login.forgotPassword': 'Glömt lösenord?',
  'auth.login.submit': 'Logga in',
  'auth.login.noAccount': 'Inget konto ännu?',
  'auth.login.signUp': 'Registrera dig',
  'auth.register.title': 'Registrera',
  'auth.register.headline': 'Skapa ditt konto',
  'auth.register.subtitle':
    'Börja analysera dina affärsidéer idag.',
  'auth.register.submit': 'Skapa konto',
  'auth.register.hasAccount': 'Har du redan ett konto?',
  'auth.register.signIn': 'Logga in',
  'auth.fields.name': 'Fullständigt namn',
  'auth.fields.email': 'E-postadress',
  'auth.fields.password': 'Lösenord',
  'auth.fields.confirmPassword': 'Bekräfta lösenord',
  'auth.fields.selectPlan': 'Välj din plan',
  'auth.fields.testCode': 'Logga in och testa gratis',
  'auth.placeholders.name': 'Ange ditt namn',
  'auth.placeholders.email': 'Ange din e-post',
  'auth.placeholders.password': 'Ange ditt lösenord',
  'auth.placeholders.confirmPassword': 'Bekräfta ditt lösenord',
  'auth.placeholders.testCode': 'Ange testkod',
  'auth.terms.accept': 'Jag accepterar',
  'auth.terms.terms': 'Användarvillkor',
  'auth.privacy.accept': 'Jag accepterar',
  'auth.privacy.policy': 'Integritetspolicy',
  'auth.errors.nameRequired': 'Namn krävs',
  'auth.errors.emailRequired': 'E-post krävs',
  'auth.errors.emailInvalid': 'Ange en giltig e-postadress',
  'auth.errors.passwordRequired': 'Lösenord krävs',
  'auth.errors.passwordLength': 'Lösenordet måste vara minst 8 tecken',
  'auth.errors.passwordMismatch': 'Lösenorden matchar inte',
  'auth.errors.invalidCode': 'Ogiltig eller utgången kod',
  'auth.errors.registrationCodeOnly': 'Denna kod är endast för registrering',
  'auth.errors.verificationFailed': 'Fel vid verifiering av kod. Försök igen.',
  'auth.loading': 'Var god vänta...',
  'auth.or': 'eller fortsätt med',
  'auth.social.google': 'Fortsätt med Google',
  'auth.social.apple': 'Fortsätt med Apple',
  'auth.actions.verify': 'Verifiera',
  'auth.testCode.activated': 'Testkod aktiverad!',
  'auth.testCode.days': 'dagar',
  'auth.testCode.months': 'månader',
  'auth.testCode.freeAccess': 'gratis åtkomst',
  'auth.testCode.credits': 'credits',

  // Email Verification
  'auth.verification.title': 'Verifiera e-post',
  'auth.verification.headline': 'Kontrollera din inkorg',
  'auth.verification.subtitle': 'Vi skickade en verifieringskod till:',
  'auth.verification.codeLabel': 'Verifieringskod',
  'auth.verification.codePlaceholder': 'Ange 6-siffrig kod',
  'auth.verification.submit': 'Verifiera e-post',
  'auth.verification.resend': 'Skicka kod igen',
  'auth.verification.resendIn': 'Skicka igen om',
  'auth.verification.seconds': 'sekunder',
  'auth.verification.success': 'E-post verifierad!',
  'auth.verification.error': 'Ogiltig kod. Försök igen.',
  'auth.verification.expired': 'Koden har löpt ut. Begär en ny.',
  'auth.verification.sent': 'Ny kod skickad!',
  'auth.verification.checkSpam':
    'Fick du inte den? Kontrollera din skräppostmapp.',

  // Forgot Password
  'auth.forgot.title': 'Glömt lösenord',
  'auth.forgot.headline': 'Återställ ditt lösenord',
  'auth.forgot.subtitle':
    'Ange din e-postadress så skickar vi en återställningslänk.',
  'auth.forgot.submit': 'Skicka återställningslänk',
  'auth.forgot.backToLogin': 'Tillbaka till inloggning',
  'auth.forgot.success': 'E-post skickad!',
  'auth.forgot.successMessage':
    'Vi har skickat ett e-postmeddelande med instruktioner för att återställa ditt lösenord.',
  'auth.forgot.checkInbox': 'Kontrollera din inkorg',

  // Reset Password
  'auth.reset.title': 'Nytt lösenord',
  'auth.reset.headline': 'Ange nytt lösenord',
  'auth.reset.subtitle': 'Ange ditt nya lösenord.',
  'auth.reset.newPassword': 'Nytt lösenord',
  'auth.reset.confirmNewPassword': 'Bekräfta nytt lösenord',
  'auth.reset.submit': 'Ändra lösenord',
  'auth.reset.success': 'Lösenordet har ändrats!',
  'auth.reset.successMessage':
    'Du kan nu logga in med ditt nya lösenord.',
  'auth.reset.loginNow': 'Logga in nu',

  // Legal Pages
  'legal.backToAuth': 'Tillbaka till inloggning',
  'legal.allRightsReserved': 'Alla rättigheter förbehållna.',

  // Terms Page
  'legal.terms.title': 'Användarvillkor',
  'legal.terms.lastUpdated': 'Senast uppdaterad',
  'legal.terms.section1.title': '1. Omfattning',
  'legal.terms.section1.content':
    'Dessa användarvillkor gäller för alla avtal mellan IdeaVerdict (nedan "Leverantören") och användaren (nedan "Kunden") angående användningen av den AI-drivna nischanalysplattformen.',
  'legal.terms.section2.title': '2. Tjänstebeskrivning',
  'legal.terms.section2.content':
    'Leverantören erbjuder en AI-baserad plattform som analyserar och utvärderar affärsidéer och nischer. Tjänsterna inkluderar:',
  'legal.terms.section2.item1': 'AI-driven analys av affärsidéer',
  'legal.terms.section2.item2': 'Utvärdering av marknadspotential och konkurrens',
  'legal.terms.section2.item3': 'Generering av nischförslag',
  'legal.terms.section2.item4': 'Skapande av utvecklarbriefingar (Builder-paket)',
  'legal.terms.section3.title': '3. Avtalsslutande och registrering',
  'legal.terms.section3.content':
    'Avtalet ingås genom registrering på plattformen och val av paket. Kunden bekräftar:',
  'legal.terms.section3.item1': 'Att vara myndig och ha full rättskapacitet',
  'legal.terms.section3.item2': 'Att lämna sanningsenlig information vid registrering',
  'legal.terms.section3.item3': 'Att förvara inloggningsuppgifter säkert',
  'legal.terms.section4.title': '4. Credits och fakturering',
  'legal.terms.section4.content':
    'Användningen av AI-funktioner baseras på ett creditsystem. Varje AI-förfrågan kostar 30 credits. Credits dras endast vid lyckat svar. Oanvända credits löper ut i slutet av faktureringsperioden och återbetalas inte.',
  'legal.terms.section5.title': '5. Friskrivning',
  'legal.terms.section5.content':
    'AI-utvärderingar är endast beslutsstöd och garanterar inte affärsframgång. Leverantören ansvarar inte för beslut som fattas baserat på AI-analyser. Ansvar för uppsåt och grov vårdslöshet påverkas inte.',
  'legal.terms.section6.title': '6. Dataskydd och sekretess',
  'legal.terms.section6.content':
    'Alla inskickade affärsidéer behandlas konfidentiellt och delas inte med tredje part. Behandling av personuppgifter sker i enlighet med vår integritetspolicy och tillämpliga dataskyddslagar.',
  'legal.terms.section7.title': '7. Uppsägning',
  'legal.terms.section7.content':
    'Kunden kan när som helst säga upp sin prenumeration vid slutet av den aktuella faktureringsperioden. Vid överträdelse av dessa villkor förbehåller sig Leverantören rätten att blockera åtkomst till plattformen.',
  'legal.terms.section8.title': '8. Slutbestämmelser',
  'legal.terms.section8.content':
    'Schweizisk lag gäller. Behörig domstol är Zürich, Schweiz. Om enskilda bestämmelser i dessa villkor är ogiltiga, påverkas inte giltigheten av de återstående bestämmelserna.',
  'legal.terms.contact.title': 'Frågor om villkoren?',
  'legal.terms.contact.content':
    'Om du har frågor om dessa användarvillkor, vänligen kontakta oss på:',

  // Privacy Page
  'legal.privacy.title': 'Integritetspolicy',
  'legal.privacy.section1.title': '1. Personuppgiftsansvarig',
  'legal.privacy.section1.content':
    'Personuppgiftsansvarig för denna webbplats är IdeaVerdict, Zürich, Schweiz. Vi tar skyddet av dina personuppgifter på största allvar och behandlar dina personuppgifter konfidentiellt och i enlighet med lagstadgade dataskyddsbestämmelser.',
  'legal.privacy.section2.title': '2. Insamlade uppgifter',
  'legal.privacy.section2.content':
    'Vi samlar in och behandlar följande personuppgifter:',
  'legal.privacy.section2.item1':
    'Registreringsuppgifter: Namn, e-postadress, lösenord (krypterat)',
  'legal.privacy.section2.item2':
    'Användningsdata: IP-adress, webbläsartyp, åtkomsttider',
  'legal.privacy.section2.item3':
    'Affärsidéer och nischfrågor (lagras anonymt)',
  'legal.privacy.section2.item4':
    'Betalningsinformation (via säkra tredjepartsleverantörer)',
  'legal.privacy.section3.title': '3. Syfte med databehandling',
  'legal.privacy.section3.content':
    'Dina uppgifter används för följande ändamål:',
  'legal.privacy.section3.item1':
    'Tillhandahållande och förbättring av våra AI-tjänster',
  'legal.privacy.section3.item2':
    'Kontohantering och autentisering',
  'legal.privacy.section3.item3':
    'Fakturering och betalningshantering',
  'legal.privacy.section4.title': '4. Datasäkerhet',
  'legal.privacy.section4.content':
    'Vi implementerar tekniska och organisatoriska säkerhetsåtgärder för att skydda dina uppgifter mot manipulation, förlust, förstörelse eller obehörig åtkomst. All dataöverföring krypteras via SSL/TLS.',
  'legal.privacy.section5.title': '5. Sekretess för dina affärsidéer',
  'legal.privacy.section5.content':
    'Dina inskickade affärsidéer och nischfrågor behandlas strikt konfidentiellt. De delas inte med tredje part, används inte för träningsändamål och kan raderas helt på begäran. Dina idéer tillhör dig.',
  'legal.privacy.section6.title': '6. Dina rättigheter',
  'legal.privacy.section6.content':
    'Du har följande rättigheter angående dina personuppgifter:',
  'legal.privacy.section6.item1': 'Rätt till tillgång till lagrade uppgifter',
  'legal.privacy.section6.item2': 'Rätt till rättelse av felaktiga uppgifter',
  'legal.privacy.section6.item3': 'Rätt till radering av dina uppgifter',
  'legal.privacy.section6.item4': 'Rätt till dataportabilitet',
  'legal.privacy.section7.title': '7. Cookies',
  'legal.privacy.section7.content':
    'Vår webbplats använder endast tekniskt nödvändiga cookies för autentisering och sessionshantering. Vi använder inte spårningscookies eller tredjepartsanalysverktyg utan ditt uttryckliga samtycke.',
  'legal.privacy.section8.title': '8. Ändringar av denna integritetspolicy',
  'legal.privacy.section8.content':
    'Vi förbehåller oss rätten att anpassa denna integritetspolicy för att följa ändrade lagkrav eller när ändringar av tjänsten sker. Den aktuella versionen finns alltid på denna sida.',
  'legal.privacy.contact.title': 'Frågor om integritet?',
  'legal.privacy.contact.content':
    'Om du har frågor om behandlingen av dina personuppgifter, vänligen kontakta oss på:',

  'auth.passwordStrength.label': 'Lösenordsstyrka',
  'auth.passwordStrength.weak': 'Svagt',
  'auth.passwordStrength.medium': 'Medel',
  'auth.passwordStrength.strong': 'Starkt',
  'auth.passwordStrength.veryStrong': 'Mycket starkt',
  'auth.passwordStrength.minLength': 'Min. 8 tecken',
  'auth.passwordStrength.uppercase': 'Versal',
  'auth.passwordStrength.number': 'Siffra',
  'auth.passwordStrength.special': 'Specialtecken',

  trial: {
    subtitle: 'Gratis provperiod',
    upgrade: 'Uppgradera nu',
    creditsRemaining: 'credits kvar',
    inputHint: 'Provversion - Ingen konversationshistorik tillgänglig',
    banner: {
      title: '7-dagars provperiod aktiv',
      remaining: '{{days}} dagar kvar',
      credits: 'credits tillgängliga',
      upgradeNow: 'Uppgradera nu',
    },
    welcome: {
      title: 'Välkommen till gratis provperioden!',
      desc: 'Testa vår AI-assistent gratis i 7 dagar med 100 credits. Ställ frågor och upptäck möjligheterna!',
    },
    info: {
      title: 'Begränsningar i provperioden',
      credits: '100 credits i 7 dagar',
      noHistory: 'Ingen konversationshistorik',
      noSettings: 'Begränsade funktioner',
      upgrade: 'Uppgradera för alla funktioner',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': 'Inställningar',
  'settings.subtitle': 'Hantera ditt konto och dina preferenser',
  'settings.backToOverview': 'Tillbaka till översikten',
  'settings.subscriptionLink': 'Prenumeration & fakturering',
  'settings.saved': 'Ändringar sparades',
  'settings.changesSaved': 'Ändringar sparade',
  'settings.saveChanges': 'Spara ändringar',
  'settings.dataExported': 'Data exporterades',

  // Tabs
  'settings.tabs.profile': 'Profil',
  'settings.tabs.preferences': 'Preferenser',
  'settings.tabs.notifications': 'Aviseringar',
  'settings.tabs.account': 'Konto & plan',

  // Profile
  'settings.profile.changePhoto': 'Byt bild',
  'settings.profile.photoHint': 'JPG, PNG eller GIF (max 2 MB)',
  'settings.profile.uploading': 'Laddar upp...',
  'settings.profile.photoUpdated': 'Profilbild uppdaterad!',
  'settings.profile.name': 'Namn',
  'settings.profile.email': 'E-post',
  'settings.profile.phone': 'Telefon',
  'settings.profile.changePassword': 'Byt lösenord',
  'settings.profile.currentPassword': 'Nuvarande lösenord',
  'settings.profile.newPassword': 'Nytt lösenord',
  'settings.profile.confirmPassword': 'Bekräfta lösenord',

  // Preferences
  'settings.preferences.language': 'Språk',
  'settings.preferences.chooseLanguage': 'Välj språk',
  'settings.preferences.timezone': 'Tidszon',
  'settings.preferences.currency': 'Valuta',

  // Notifications
  'settings.notifications.emailTitle': 'E-postaviseringar',
  'settings.notifications.email.analysis': 'Analys klar',
  'settings.notifications.email.analysisDesc': 'Få ett e-postmeddelande när din analys är klar',
  'settings.notifications.email.credits': 'Credit-uppdateringar',
  'settings.notifications.email.creditsDesc': 'Aviseringar om credits och återställningar',
  'settings.notifications.email.billing': 'Fakturor & betalningar',
  'settings.notifications.email.billingDesc': 'Aviseringar om fakturor och planändringar',
  'settings.notifications.email.newsletter': 'Nyhetsbrev',
  'settings.notifications.email.newsletterDesc': 'Tips, uppdateringar och nya funktioner',
  'settings.notifications.pushTitle': 'Push-aviseringar',
  'settings.notifications.push.analysis': 'Analys klar',
  'settings.notifications.push.analysisDesc': 'Webbläsaravisering när analysen är klar',
  'settings.notifications.push.credits': 'Credit-varningar',
  'settings.notifications.push.creditsDesc': 'Varning när credit-saldot är lågt',

  // Account
  'settings.account.currentSubscription': 'Nuvarande prenumeration',
  'settings.account.plan': 'Plan',
  'settings.account.price': 'Pris',
  'settings.account.nextBilling': 'Nästa fakturering',
  'settings.account.manageSubscription': 'Hantera prenumeration & betalningar',
  'settings.account.dataPrivacy': 'Data & integritet',
  'settings.account.exportData': 'Exportera data',
  'settings.account.deleteAccount': 'Radera konto',

  // Delete Modal
  'settings.deleteModal.title': 'Radera konto?',
  'settings.deleteModal.subtitle': 'All data kommer att raderas permanent.',
  'settings.deleteModal.warning1': 'Alla analyser och data kommer att raderas',
  'settings.deleteModal.warning2': 'Aktiv prenumeration avslutas omedelbart',
  'settings.deleteModal.warning3': 'Ingen återbetalning möjlig',
  'settings.deleteModal.confirmLabel': 'Skriv "{{word}}" för att bekräfta *',
  'settings.deleteModal.cancel': 'Avbryt',
  'settings.deleteModal.confirm': 'Radera konto',

  // ─── Subscription & Billing ─────────────────────────────────────────────
  'sub.backToOverview': 'Tillbaka till översikten',
  'sub.settings': 'Inställningar',
  'sub.title': 'Prenumeration & fakturering',
  'sub.subtitle': 'Hantera din prenumeration, betalningsmetoder och fakturor',
  'sub.tab.overview': 'Översikt',
  'sub.tab.payment': 'Betalningsmetoder',
  'sub.tab.billing': 'Faktureringsadress',
  'sub.tab.history': 'Betalningshistorik',
  'sub.memberSince': 'Medlem sedan',
  'sub.perMonth': 'per månad',
  'sub.baseCHF': '(CHF {{amount}} bas)',
  'sub.nextBilling': 'Nästa fakturering',
  'sub.creditsUsed': 'Credits använda',
  'sub.paymentMethod': 'Betalningsmetod',
  'sub.creditUsage': 'Credit-användning',
  'sub.changePlan': 'Byt plan',
  'sub.reactivate': 'Återaktivera',
  'sub.cancelSub': 'Säg upp prenumeration',
  'sub.manageCards': 'Hantera kort',
  'sub.downloadInvoices': 'Ladda ner fakturor',
  'sub.invoicesAvailable': '{{count}} fakturor tillgängliga som PDF',
  'sub.accountSettings': 'Kontoinställningar',
  'sub.profileNotifications': 'Profil, aviseringar och mer',
  // Prices in EUR info
  'sub.eurInfo': 'Priser visas i',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Kurs:',
  'sub.currentRate': 'Aktuell kurs',
  // Payment Methods
  'sub.savedCards': 'Sparade kort',
  'sub.newCard': 'Nytt kort',
  'sub.default': 'Standard',
  'sub.setDefault': 'Ange som standard',
  'sub.validUntil': 'Giltigt till',
  'sub.noCards': 'Inga kort sparade',
  'sub.addFirstCard': 'Lägg till första kortet',
  'sub.securePayments': 'Säkra betalningar',
  'sub.securePaymentsDesc': 'All betalningsdata överförs krypterat och lagras säkert hos vår betalleverantör. Vi lagrar inte fullständiga kortnummer.',
  // Billing Address
  'sub.billingAddress': 'Faktureringsadress',
  'sub.edit': 'Redigera',
  'sub.name': 'Namn',
  'sub.streetAddress': 'Gata & nummer',
  'sub.zip': 'Postnummer',
  'sub.city': 'Stad',
  'sub.country': 'Land',
  'sub.address': 'Adress',
  'sub.save': 'Spara',
  'sub.cancel': 'Avbryt',
  'sub.country.switzerland': 'Schweiz',
  'sub.country.germany': 'Tyskland',
  'sub.country.austria': 'Österrike',
  'sub.country.netherlands': 'Nederländerna',
  'sub.country.belgium': 'Belgien',
  // Payment History
  'sub.paymentHistory': 'Betalningshistorik',
  'sub.allInvoicesPDF': 'Ladda ner alla fakturor som PDF med logotyp',
  'sub.downloadAll': 'Ladda ner alla',
  'sub.eurInvoiceNote': 'Fakturor utfärdas alltid i CHF. Visade EUR-belopp är endast vägledande.',
  'sub.date': 'Datum',
  'sub.description': 'Beskrivning',
  'sub.net': 'Netto',
  'sub.vat': 'Moms',
  'sub.total': 'Totalt',
  'sub.status': 'Status',
  'sub.pdf': 'PDF',
  'sub.invoices': 'fakturor',
  'sub.totalAmount': 'Totalt belopp',
  // Change Plan Modal
  'sub.changePlanTitle': 'Byt plan',
  'sub.current': 'Nuvarande',
  'sub.month': '/månad',
  'sub.showLess': 'Visa mindre',
  'sub.showMore': '+{{count}} fler',
  'sub.switchPlan': 'Byt plan',
  'sub.eurPriceNote': 'Priser visas i EUR ({{note}}). Fakturering sker i CHF.',
  // Cancel Modal
  'sub.cancelTitle': 'Säker på att du vill säga upp prenumerationen?',
  'sub.cancelIrreversible': 'Denna åtgärd kan inte ångras.',
  'sub.cancelWarning1': 'Alla återstående credits kommer att förfalla',
  'sub.cancelWarning2': 'Nedgradering till gratisplanen',
  'sub.cancelWarning3': 'Förlust av alla premiumfunktioner',
  'sub.pauseInstead': 'Alternativ: Pausa prenumerationen?',
  'sub.pauseDesc': 'Pausa din prenumeration istället och behåll din data.',
  'sub.preferPause': 'Föredrar att pausa',
  'sub.cancelReason': 'Anledning till uppsägning',
  'sub.selectReason': 'Vänligen välj...',
  'sub.reason.tooExpensive': 'För dyrt',
  'sub.reason.notUsing': 'Använder det inte tillräckligt',
  'sub.reason.missingFeatures': 'Saknade funktioner',
  'sub.reason.foundAlternative': 'Hittat ett alternativ',
  'sub.reason.other': 'Annat',
  'sub.confirmType': 'Bekräftelse: Skriv "CANCEL" *',
  'sub.cancelNow': 'Säg upp nu',
  // Add Card Modal
  'sub.addCardTitle': 'Lägg till nytt kort',
  'sub.cardHolder': 'Kortinnehavare *',
  'sub.cardNumber': 'Kortnummer *',
  'sub.expiryDate': 'Utgångsdatum *',
  'sub.addCard': 'Lägg till kort',
  // Change Card Modal
  'sub.choosePayment': 'Välj betalningsmetod',
  'sub.active': 'Aktiv',
  'sub.close': 'Stäng',
  // Toast messages
  'sub.toast.cancelled': 'Din prenumeration har sagts upp vid slutet av faktureringsperioden.',
  'sub.toast.reactivated': 'Din prenumeration har återaktiverats!',
  'sub.toast.planChanged': 'Plan ändrad till {{plan}}!',
  'sub.toast.defaultChanged': 'Standardbetalningsmetod ändrad.',
  'sub.toast.cannotDeleteDefault': 'Standardkortet kan inte raderas.',
  'sub.toast.cardRemoved': 'Kortet har tagits bort.',
  'sub.toast.fillAll': 'Fyll i alla fält.',
  'sub.toast.cardAdded': 'Nytt kort har lagts till!',
  'sub.toast.billingSaved': 'Faktureringsadress sparad.',
  'sub.toast.invoiceDownloaded': 'Faktura {{id}} nedladdad!',
  'sub.toast.pdfError': 'Fel vid skapande av PDF.',
  // Chat interface
  'sub.notEnoughCredits': 'Inte tillräckligt med credits',
  'sub.needCredits': 'Du behöver minst {{count}} credits per fråga.',
  'sub.creditsLow': 'Credits håller på att ta slut',
  'sub.questionsLeft': '{{count}} frågor möjliga.',
  'sub.plan': 'Plan',
  'sub.base': 'bas',
  'sub.unlimited': 'Obegränsat',
  'sub.status.active': 'Aktiv',
  'sub.status.cancelled': 'Uppsagd',
  'sub.status.paused': 'Pausad',
  'sub.invoice': 'FAKTURA',
  'sub.from': 'FRÅN',
  'sub.to': 'TILL',
  'sub.vatId': 'Momsnr',
  'sub.tel': 'Tel',
  'sub.invoiceDate': 'Fakturadatum',
  'sub.invoiceNumber': 'Fakturanummer',
  'sub.paymentStatus': 'Betalningsstatus',
  'sub.creditCard': 'Kreditkort',
  'sub.quantity': 'ANT',
  'sub.price': 'PRIS',
  'sub.amount': 'BELOPP',
  'sub.subtotal': 'Delsumma',
  'sub.bank': 'Bank',
  'sub.card': 'Kort',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'John Doe',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': 'Admin-instrumentpanel',
  'admin.subtitle': 'Kontrollcenter',
  'admin.superAdmin': 'Superadmin',
  'admin.logout': 'Logga ut',
  'admin.tabs.users': 'Användarhantering',
  'admin.tabs.downgrades': 'Nedgraderingar',
  'admin.tabs.tips': 'Dagens tips',
  'admin.tabs.coupons': 'Rabattkoder',
  'admin.tabs.website': 'Webbredigerare',
  'admin.tabs.ai': 'AI-inställningar',
  'admin.tabs.transactions': 'Transaktionslogg',
  'admin.tabs.stats': 'Statistik',
  'admin.users.searchPlaceholder': 'Sök användare (e-post eller namn)...',
  'admin.users.manageSubscription': 'Hantera prenumeration',
  'admin.users.grantFree': 'Bevilja gratis konto',
  'admin.users.blockUser': 'Blockera användare',
  'admin.users.cancellationPlaceholder': 'Varför avslutas prenumerationen?',
  'admin.users.selectPlan': 'Välj plan',
  'admin.users.subChanged': 'Prenumeration för {{name}} ändrad till {{plan}}',
  'admin.users.noReasonGiven': 'Ingen anledning angiven',
  'admin.users.subCancelled': 'Prenumeration för {{name}} uppsagd (gäller till {{date}})',
  'admin.users.paused': 'Pausad',
  'admin.users.subPaused': 'Prenumeration för {{name}} har pausats',
  'admin.users.subReactivated': 'Prenumeration för {{name}} har återaktiverats',
  'admin.users.freeAccount': 'Gratis konto',
  'admin.users.blocked': 'Blockerad',
  'admin.users.cancelledExpiring': 'Uppsagd (löper ut)',
  'admin.users.cancelledOn': 'Uppsagd:',
  'admin.users.endsOn': 'Slutar:',
  'admin.users.daysRemaining': 'dagar kvar',
  'admin.users.expired': '(Utgången)',
  'admin.users.total': 'Totalt:',
  'admin.users.usersLabel': 'användare',
  'admin.users.free': 'gratis',
  'admin.users.block': 'Blockera',
  'admin.users.unblock': 'Avblockera',
  'admin.users.unblockUser': 'Avblockera användare',
  'admin.users.selectAction': 'Välj åtgärd',
  'admin.users.cancelSub': 'Säg upp prenumeration',
  'admin.users.cancelSubDesc': 'Uppsägning vid månadsskiftet',
  'admin.users.pauseSub': 'Pausa prenumeration',
  'admin.users.pauseSubDesc': 'Tillfällig paus',
  'admin.users.changePlan': 'Byt plan',
  'admin.users.changePlanDesc': 'Byt till en annan plan',
  'admin.users.reactivateSub': 'Återaktivera prenumeration',
  'admin.users.reactivateDesc': 'Ångra uppsägning',
  'admin.users.alreadyCancelled': 'Prenumeration redan uppsagd',
  'admin.users.planLabel': 'Plan',
  'admin.users.cancellationReasonOpt': 'Anledning till uppsägning (valfritt)',
  'admin.users.cancelInfo1': 'Prenumerationen avslutas den',
  'admin.users.cancelInfo2': '(vid månadsskiftet). Fram till dess har användaren full åtkomst. Ingen återbetalning.',
  'admin.users.newPlan': 'Ny plan',
  'admin.users.warning': 'Varning',
  'admin.users.blockDesc': 'Användaren kommer omedelbart att loggas ut och kan inte logga in igen. Alla aktiva sessioner avslutas.',
  'admin.users.confirmUnblock': 'Bekräfta avblockering',
  'admin.users.unblockDesc': 'Användaren kan logga in igen och använda alla funktioner.',
  'admin.users.afterBlock': 'Efter blockering:',
  'admin.users.afterUnblock': 'Efter avblockering:',
  'admin.users.noAccountAccess': 'Ingen kontotillgång',
  'admin.users.noNewAnalyses': 'Inga nya analyser möjliga',
  'admin.users.creditsStored': 'Credits och historik finns kvar',
  'admin.users.accessRestored': 'Kontotillgång återställd',
  'admin.users.allFeaturesAvail': 'Alla funktioner tillgängliga igen',
  'admin.users.creditsPreserved': 'Credits och historik bevarade',
  'admin.users.downgrade': 'Nedgradera plan',
  'admin.users.grantFreeBtn': 'Bevilja gratis',
  'admin.users.durationMonths': 'Längd (månader)',
  'admin.users.months': 'månad(er)',
  'admin.users.freePlan': 'gratis',
  'admin.users.freeSummary': 'får',
  'admin.users.withCredits': 'med',
  'admin.users.credits': 'Credits',
  'admin.users.subInfo': 'Prenumerationsinformation',
  'admin.users.currentPlan': 'Nuvarande plan',
  'admin.users.joined': 'Blev medlem',
  'admin.users.totalSpent': 'Totalt spenderat',
  'admin.users.paymentMethod': 'Betalningsmetod',
  'admin.users.validThrough': 'Giltigt till',
  'admin.users.billingAddress': 'Faktureringsadress',
  'admin.users.transactionHistory': 'Transaktionshistorik',
  'admin.users.cancellationDate': 'Uppsägningsdatum',
  'admin.users.validUntil': 'Giltigt till (vid månadsskiftet)',
  'admin.users.cancellationReason': 'Uppsägningsanledning',
  'admin.users.noReason': 'Ingen anledning angiven',
  'admin.users.timeRemaining': 'Återstående tid',
  'admin.users.daysUntilDeactivation': 'dagar tills avaktivering',
  'admin.table.user': 'Användare',
  'admin.table.plan': 'Plan',
  'admin.table.subStatus': 'Prenumerationsstatus',
  'admin.table.cancellation': 'Uppsägning',
  'admin.table.payment': 'Betalningsmetod',
  'admin.table.spending': 'Utgifter',
  'admin.table.actions': 'Åtgärder',
  'admin.actions.viewDetails': 'Visa detaljer',
  'admin.actions.manageSubscription': 'Hantera prenumeration',
  'admin.actions.grantFree': 'Bevilja gratis åtkomst',
  'admin.actions.block': 'Blockera användare',
  'admin.actions.unblock': 'Avblockera användare',
  'admin.actions.cancel': 'Avbryt',
  'admin.actions.save': 'Spara',
  'admin.actions.delete': 'Radera',
  'admin.actions.confirm': 'Bekräfta',
  'admin.actions.done': 'Klart',
  'admin.actions.edit': 'Redigera',
  'admin.actions.close': 'Stäng',
  'admin.table.status': 'Status',
  'admin.filter.all': 'Alla',
  'admin.subscription.active': 'Aktiv',
  'admin.subscription.cancelled': 'Uppsagd',
  'admin.subscription.paused': 'Pausad',
  'admin.subscription.unknown': 'Okänd',
  'admin.status.active': 'Aktiv',
  'admin.status.inactive': 'Inaktiv',
  'admin.status.pending': 'Väntande',
  'admin.status.approved': 'Godkänd',
  'admin.status.rejected': 'Avvisad',
  'admin.coupons.title': 'Rabatthantering',
  'admin.coupons.subtitle': 'Skapa och hantera rabattkoder',
  'admin.coupons.newCoupon': 'Ny rabattkod',
  'admin.coupons.registrationCoupons': 'Registreringskoder',
  'admin.coupons.trialCoupons': 'Teståtkomstkoder',
  'admin.coupons.type': 'Typ',
  'admin.coupons.plan': 'Plan',
  'admin.coupons.value': 'Värde',
  'admin.coupons.usage': 'Användning',
  'admin.coupons.validUntil': 'Giltig till',
  'admin.coupons.created': 'Skapad',
  'admin.coupons.actions': 'Åtgärder',
  'admin.coupons.copyCode': 'Kopiera kod',
  'admin.coupons.allPlans': 'Alla planer',
  'admin.coupons.discount': 'Rabatt',
  'admin.coupons.days': 'dagar',
  'admin.coupons.months': 'månader',
  'admin.coupons.free': 'gratis',
  'admin.coupons.unlimited': 'Obegränsat',
  'admin.coupons.createRegistration': 'Skapa registreringskod',
  'admin.coupons.createTrial': 'Skapa teståtkomstkod',
  'admin.coupons.couponCode': 'Rabattkod',
  'admin.coupons.codePlaceholder': 't.ex. NF-7X3K9M',
  'admin.coupons.generateCode': 'Generera ny kod',
  'admin.coupons.alertFillRequired': 'Fyll i alla obligatoriska fält',
  'admin.coupons.alertSelectExpiry': 'Välj ett utgångsdatum eller aktivera "Obegränsad giltighet"',
  'admin.coupons.alertCreateError': 'Fel vid skapande av rabattkod',
  'admin.coupons.confirmDelete': 'Är du säker på att du vill radera denna rabattkod?',
  'admin.coupons.discountPercent': 'Rabatt (%)',
  'admin.coupons.bonusCredits': 'Bonuscredits',
  'admin.coupons.freeDuration': 'Gratisperiod',
  'admin.coupons.maxUses': 'Max antal användningar',
  'admin.coupons.expiryDate': 'Utgångsdatum',
  'admin.coupons.unlimitedValidity': 'Obegränsad giltighet',
  'admin.coupons.unlimitedUses': 'Obegränsad användning',
  'admin.coupons.trialCredits': 'Testcredits',
  'admin.coupons.trialDuration': 'Testperiod',
  'admin.coupons.typePlaceholder': 't.ex. Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'Varaktighet',
  'admin.stats.totalUsers': 'Totalt antal användare',
  'admin.stats.monthlyRevenue': 'Månadsintäkter',
  'admin.stats.activeSubscriptions': 'Aktiva prenumerationer',
  'admin.stats.average': 'Genomsnitt',
  'admin.stats.revenuePerUser': 'Intäkt per användare',
  'admin.stats.grossRevenue': 'Bruttointäkter',
  'admin.stats.net': 'NETTO',
  'admin.stats.netRevenue': 'Nettointäkter',
  'admin.stats.churnRate': 'Churn-rate',
  'admin.stats.planDistribution': 'Planfördelning',
  'admin.stats.users': 'användare',
  'admin.stats.revenueByPlan': 'Intäkter per plan',
  'admin.stats.recentActivity': 'Senaste aktivitet',
  'admin.stats.activity1': 'Thomas Weber uppgraderade till Builder',
  'admin.stats.activity2': 'Ny användare registrerade sig',
  'admin.stats.activity3': 'Anna Schmidt uppgraderade till Pro',
  'admin.stats.hoursAgo2': '2 timmar sedan',
  'admin.stats.hoursAgo5': '5 timmar sedan',
  'admin.stats.dayAgo1': '1 dag sedan',
  'admin.stats.couponStats': 'Rabattstatistik',
  'admin.stats.totalRedemptions': 'Totalt antal inlösen',
  'admin.stats.activeCoupons': 'Aktiva rabattkoder',
  'admin.stats.registrationRedemptions': 'Registreringsinlösen',
  'admin.stats.trialRedemptions': 'Testinlösen',
  'admin.stats.couponDistribution': 'Rabattfördelning',
  'admin.stats.registrationCoupons': 'Registreringskoder',
  'admin.stats.trialCoupons': 'Testkoder',
  'admin.stats.expiredInactive': 'Utgångna/inaktiva',
  'admin.stats.topCoupons': 'Mest använda rabattkoder',
  'admin.stats.redemptions': 'inlösen',
  'admin.stats.noCouponsRedeemed': 'Inga rabattkoder har lösts in ännu',
  'admin.downgrade.pending': 'väntande',
  'admin.downgrade.refunds': 'Återbetalningar',
  'admin.downgrade.sectionRequests': 'Förfrågningar',
  'admin.downgrade.sectionStats': 'Statistik',
  'admin.downgrade.sectionRules': 'Regler',
  'admin.downgrade.pendingRequests': 'Väntande förfrågningar',
  'admin.downgrade.approvedRequests': 'Godkända förfrågningar',
  'admin.downgrade.rejectedRequests': 'Avvisade förfrågningar',
  'admin.downgrade.activeRules': 'Aktiva regler',
  'admin.downgrade.autoRules': 'Automatiska nedgraderingsregler',
  'admin.downgrade.autoRulesDesc': 'Skapa regler som automatiskt utlöser nedgraderingar baserat på användarbeteende',
  'admin.downgrade.newRule': 'Ny regel',
  'admin.downgrade.totalRules': 'Totalt antal regler',
  'admin.downgrade.triggeredActions': 'Utlösta åtgärder',
  'admin.downgrade.conditionsAnd': 'Villkor (AND-kopplade)',
  'admin.downgrade.action': 'Åtgärd',
  'admin.downgrade.successTitle': 'Nedgradering lyckades!',
  'admin.downgrade.successDesc': 'Användaren har framgångsrikt nedgraderats och återbetalningen har behandlats.',
  'admin.downgrade.closing': 'Stänger...',
  'admin.downgrade.title': 'Nedgradera användare',
  'admin.downgrade.currentPlan': 'Nuvarande plan',
  'admin.downgrade.spending': 'Utgifter',
  'admin.downgrade.availablePlans': 'Tillgängliga planer för nedgradering',
  'admin.downgrade.perMonth': 'per månad',
  'admin.downgrade.refundCalc': 'Återbetalningsberäkning',
  'admin.downgrade.currentPlanLabel': 'Nuvarande plan',
  'admin.downgrade.newPlan': 'Ny plan',
  'admin.downgrade.remainingDays': 'Återstående dagar',
  'admin.downgrade.daysOf': '15 av 30 dagar',
  'admin.downgrade.proRataRefund': 'Proportionerlig återbetalning',
  'admin.downgrade.importantNote': 'Viktig notering',
  'admin.downgrade.warningDesc': 'Nedgraderingen kommer att utföras omedelbart. Användaren förlorar tillgång till premiumfunktioner och överskott av credits kommer att tas bort.',
  'admin.downgrade.processing': 'Bearbetar...',
  'admin.downgrade.execute': 'Utför nedgradering',
  'admin.downgrade.notification': 'Avisering',
  'admin.downgrade.noNotification': 'Ingen avisering',
  'admin.downgrade.daysPeriod': 'dagars respitperiod',
  'admin.downgrade.created': 'Skapad:',
  'admin.downgrade.triggered': 'utlöst',
  'admin.downgrade.noRules': 'Inga regler har skapats ännu',
  'admin.downgrade.createFirstRule': 'Skapa första regeln',
  'admin.downgrade.editRule': 'Redigera regel',
  'admin.downgrade.createRule': 'Skapa ny regel',
  'admin.downgrade.ruleName': 'Regelnamn',
  'admin.downgrade.description': 'Beskrivning',
  'admin.downgrade.allConditions': 'Villkor (alla måste uppfyllas)',
  'admin.downgrade.addCondition': 'Lägg till villkor',
  'admin.downgrade.type': 'Typ',
  'admin.downgrade.value': 'Värde',
  'admin.downgrade.fromPlan': 'Från plan',
  'admin.downgrade.toPlan': 'Till plan',
  'admin.condition.inactivity': 'Inaktivitet',
  'admin.condition.creditUsage': 'Credit-användning',
  'admin.condition.loginFrequency': 'Inloggningsfrekvens',
  'admin.condition.featureUsage': 'Funktionsanvändning',
  'admin.condition.supportTickets': 'Supportärenden',
  'admin.operator.lessThan': 'mindre än',
  'admin.operator.greaterThan': 'mer än',
  'admin.operator.equals': 'exakt',
  'admin.operator.between': 'mellan',
  'admin.unit.days': 'dagar',
  'admin.unit.perMonth': 'per månad',
  'admin.unit.count': 'antal',
  'admin.transactions.all': 'Alla transaktioner',
  'admin.transactions.allCards': 'Alla kort',
  'admin.transactions.notFound': 'Inga transaktioner hittades',
  'admin.transactions.totalLabel': 'Totalt',
  'admin.transactions.transactions': 'transaktioner',
  'admin.tips.title': 'Dagens tips',
  'admin.tips.subtitle': 'Skapa och hantera tips som visas för alla användare',
  'admin.tips.active': 'Aktiv',
  'admin.tips.currentlyShown': 'Detta tips visas för alla användare just nu',
  'admin.tips.createNew': 'Skapa nytt tips',
  'admin.tips.generating': 'Genererar...',
  'admin.tips.generateAI': 'Generera AI-tips',
  'admin.tips.titleLabel': 'Titel',
  'admin.tips.titlePlaceholder': 't.ex. Dagens tips',
  'admin.tips.category': 'Kategori',
  'admin.tips.categoryTip': 'Tips',
  'admin.tips.categoryFeature': 'Ny funktion',
  'admin.tips.categoryProductivity': 'Produktivitet',
  'admin.tips.categoryUpdate': 'Uppdatering',
  'admin.tips.content': 'Innehåll',
  'admin.tips.contentPlaceholder': 'Skriv ditt tips för användare här...',
  'admin.tips.addTip': 'Lägg till tips',
  'admin.tips.allTips': 'Alla tips',
  'admin.tips.noTips': 'Inga tips har skapats ännu',
  'admin.tips.noTipsHint': 'Klicka på "Generera AI-tips" för att komma igång',
  'admin.noData': 'Ingen data tillgänglig',
  'admin.range.7d': '7 dagar',
  'admin.range.30d': '30 dagar',
  'admin.range.90d': '90 dagar',
  'admin.range.1y': '1 år',
  'admin.actions.saveSettings': 'Spara inställningar',
  'admin.actions.create': 'Skapa',
  'admin.downgrade.sectionReports': 'Rapporter',
  'admin.downgrade.settings': 'Nedgraderingsinställningar',
  'admin.downgrade.autoApprove': 'Automatiskt godkännande',
  'admin.downgrade.autoApproveDesc': 'Godkänn nedgraderingsförfrågningar automatiskt',
  'admin.downgrade.refundPolicy': 'Återbetalningspolicy',
  'admin.downgrade.prorata': 'Proportionerlig återbetalning',
  'admin.downgrade.prorataDesc': 'Proportionerlig återbetalning baserat på återstående dagar',
  'admin.downgrade.fullRefund': 'Full återbetalning',
  'admin.downgrade.fullRefundDesc': 'Fullständig återbetalning av prisskillnaden',
  'admin.downgrade.noRefund': 'Ingen återbetalning',
  'admin.downgrade.noRefundDesc': 'Nedgradering utan återbetalning',
  'admin.downgrade.daysRemaining15': '(med 15 dagar kvar)',
  'admin.downgrade.requestsTitle': 'Nedgraderingsförfrågningar',
  'admin.downgrade.approvalRate': 'Godkännandegrad',
  'admin.downgrade.mostCommonTransition': 'Vanligaste övergången',
  'admin.downgrade.mostCommonReason': 'Vanligaste anledningen',
  'admin.downgrade.avgProcessingTime': 'Genomsnittlig handläggningstid',
  'admin.downgrade.avgTimeDesc': 'Genomsnittlig tid till beslut',
  'admin.downgrade.totalRefunds': 'Totala återbetalningar',
  'admin.downgrade.pendingRefunds': 'Väntande återbetalningar',
  'admin.downgrade.summary': 'Sammanfattning',
  'admin.downgrade.total': 'Totalt',
  'admin.downgrade.csvDesc': 'För Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'Ladda ner som CSV',
  'admin.downgrade.jsonDesc': 'För utvecklare, API:er',
  'admin.downgrade.downloadJSON': 'Ladda ner som JSON',
  'admin.downgrade.exportInfo': 'Exporten innehåller',
  'admin.downgrade.entries': 'poster från den valda perioden',
  'admin.downgrade.topReasons': 'Vanligaste anledningarna till nedgradering',
  'admin.downgrade.refundHistory': 'Återbetalningshistorik',
  'admin.downgrade.noRefunds': 'Inga återbetalningar ännu',
  'admin.downgrade.statistics': 'Nedgraderingsstatistik',
  'admin.downgrade.requests': 'Förfrågningar',
  'admin.downgrade.monthlyTrend': 'Månadstrend',
  'admin.downgrade.planTransitions': 'Planövergångar',
  'admin.downgrade.trend': 'Trend (jämfört med föregående månad)',
  'admin.downgrade.trendDesc': 'Färre nedgraderingar = bättre',
  'admin.coupons.allPlansUniversal': 'Alla planer (universell)',
  'admin.coupons.onlyStarter': 'Endast Starter',
  'admin.coupons.onlyPro': 'Endast Pro',
  'admin.coupons.onlyBuilder': 'Endast Builder',
  'admin.coupons.allPlansHint': 'Välj "Alla planer" för en universell rabattkod',
  'admin.coupons.discountOptional': 'Rabatt % (valfritt)',
  'admin.coupons.discountPlaceholder': 't.ex. 50 för 50% rabatt',
  'admin.coupons.bonusCreditsOptional': 'Bonuscredits (valfritt)',
  'admin.coupons.bonusCreditsPlaceholder': 't.ex. 500',
  'admin.coupons.freeDurationOptional': 'Gratisperiod (valfritt)',
  'admin.coupons.durationPlaceholder': 't.ex. 30',
  'admin.coupons.freeDurationHint': 't.ex. 30 dagar gratis att använda',
  'admin.coupons.noLimit': 'Ingen användningsbegränsning',
  'admin.coupons.noExpiry': 'Inget utgångsdatum',
  'admin.coupons.creditsPlaceholder': 't.ex. 100',
  'admin.coupons.creditsHint': 'Antal credits för teståtkomsten',
  'admin.coupons.trialDurationHint': 'Hur länge teståtkomsten är giltig',
  'admin.coupons.autoCalculated': 'Automatiskt beräknat från testperiodens längd',
  'admin.websiteEditor.title': 'Webbredigerare',
  'admin.websiteEditor.subtitle': 'Redigera alla sektioner på startsidan',
  'admin.websiteEditor.openPreview': 'Öppna förhandsgranskning',
  'admin.websiteEditor.group.structure': 'Sidstruktur',
  'admin.websiteEditor.group.design': 'Design & layout',
  'admin.websiteEditor.group.settings': 'Inställningar',
  'admin.websiteEditor.tab.navbar': 'Navigation',
  'admin.websiteEditor.tab.howitworks': 'Hur det fungerar',
  'admin.websiteEditor.tab.about': 'Om oss',
  'admin.websiteEditor.tab.pricing': 'Priser',
  'admin.websiteEditor.tab.sections': 'Sektioner',
  'admin.websiteEditor.tab.media': 'Media',
  'admin.websiteEditor.tab.chatwidget': 'Prata med oss',
  'admin.websiteEditor.tab.invoice': 'Fakturor',
  'admin.websiteEditor.tab.legal': 'Juridiskt',
  'admin.websiteEditor.tab.seo': 'Grundläggande SEO',
  'admin.websiteEditor.tab.advancedseo': 'Avancerad SEO',
  'admin.websiteEditor.tab.versions': 'Versioner',
  'admin.hero.title': 'Redigera hjältesektionen',
  'admin.hero.subtitle': 'Texter, knappar och statistik på startsidan',
  'admin.hero.reset': 'Återställ',
  'admin.hero.save': 'Spara',
  'admin.hero.savedMsg': 'Hjältedata sparad!',
  'admin.hero.badge': 'Märkestext',
  'admin.hero.headings': 'Rubriker',
  'admin.hero.line1White': 'Rad 1 (vit)',
  'admin.hero.line2Gold': 'Rad 2 (guld)',
  'admin.hero.subtitleSection': 'Underrubrik',
  'admin.hero.line1': 'Rad 1',
  'admin.hero.line2': 'Rad 2',
  'admin.hero.buttons': 'Knappar',
  'admin.hero.primaryBtn': 'Primär knapp (guld)',
  'admin.hero.secondaryBtn': 'Sekundär knapp (ram)',
  'admin.hero.stats': 'Statistik',
  'admin.hero.statN': 'Statistik {{n}}',
  'admin.hero.value': 'Värde',
  'admin.hero.label': 'Etikett',
  'admin.hero.previewNote': 'Ändringar kommer att synas på startsidan efter sparande. Ladda om sidan för att se förhandsgranskningen.',

  // Idea History
  'history.title': 'Idéhistorik',
  'history.countLabel': '{{count}} analyser',
  'history.recentLabel': 'Dina senaste analyser',
  'history.exportAll': 'Exportera alla',
  'history.metrics.marketSize': 'Marknadsstorlek',
  'history.metrics.competition': 'Konkurrens',
  'history.metrics.startingCapital': 'Startkapital',
  'history.metrics.timeToMarket': 'Time to market',
  'history.metrics.profitPotential': 'Vinstpotential',
  'history.metrics.scalability': 'Skalbarhet',
  'history.summary.title': 'Sammanfattning',
  'history.download': 'Ladda ner',
  'history.downloadJSON': 'Spara som JSON',
  'history.downloadTXT': 'Spara som TXT',
  'history.downloadPDF': 'Spara som PDF',
  'history.fullAnalysis': 'Fullständig analys',
  'history.searchPlaceholder': 'Sök efter titel eller taggar...',
  'history.filterAll': 'Alla betyg',
  'history.loading': 'Laddar analyser...',
  'history.noResults': 'Inga resultat hittades',
  'history.empty': 'Inga analyser ännu',
  'history.emptyHint': 'Starta en analys i AI-assistenten',
  'history.delete': 'Radera',
  'history.cancel': 'Avbryt',
  'history.deleteModalTitle': 'Radera analys?',
  'history.deleteModalDesc': '"{{title}}" kommer att raderas permanent.',
  'history.errorLoading': 'Fel vid laddning av analyser',
  'history.deleteSuccess': 'Analys raderad',
  'history.deleteError': 'Fel vid radering av analys',
  'history.jsonExported': 'JSON exporterad',
  'history.txtExported': 'TXT exporterad',
  'history.allExported': '{{count}} idéer exporterade',
  'history.analysisHeader': 'IDÉANALYS',
  'history.titleLabel': 'Titel',
  'history.ratingLabel': 'Betyg',
  'history.dateLabel': 'Datum',
  'history.creditsLabel': 'Credits',
  'history.analysisSection': 'Analys',

  // Overview
  'overview.title': 'Översikt',
  'overview.last24h': 'Senaste 24 timmarna',
  'overview.analysesToday': 'Analyser idag',
  'overview.totalAnalyses': 'Totalt antal analyser',
  'overview.successRate': 'Framgångsfrekvens',
  'overview.topRatings': 'Toppbetyg',
  'overview.recentActivity': 'Senaste aktivitet',
  'overview.viewAll': 'Visa alla',
  'overview.quickAccess': 'Snabbtillgång',
  'overview.quick.newAnalysis': 'Starta ny analys',
  'overview.quick.newAnalysisDesc': 'Starta en ny AI-driven nischanalys',
  'overview.quick.myAnalyses': 'Mina analyser',
  'overview.quick.myAnalysesDesc': 'Visa alla tidigare analyser',
  'overview.quick.buyCredits': 'Köp credits',
  'overview.quick.buyCreditsDesc': 'Fler credits för fler analyser',
  'overview.quick.settings': 'Inställningar',
  'overview.quick.settingsDesc': 'Anpassa profil och preferenser',
  'overview.unlimitedCredits': 'Obegränsade credits tillgängliga',
  'overview.creditsAvailable': 'credits tillgängliga',
  'overview.upgradePlan': 'Uppgradera plan',
  'overview.buyCredits': 'Köp credits',
  'overview.creditUsage': 'Credit-användning denna månad',
  'overview.available': 'tillgängliga',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'Uppgraderingar',
  'admin.transactions.downgrades': 'Nedgraderingar',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} har nu {{months}} månad(er) av gratis {{plan}}-plan',
  'admin.users.blockSuccess': '{{name}} blockerades',
  'admin.users.unblockSuccess': '{{name}} avblockerades',
  'admin.users.removeFreeSuccess': 'Gratisstatus för {{name}} togs bort',

  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Gratis',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Upptäck ny funktion',
  'admin.tips.productivityBoost': 'Produktivitetsboost',
  'admin.tips.importantUpdate': 'Viktig uppdatering',
  'admin.tips.tipOfDay': 'Dagens tips',

  'admin.actions.activate': 'Aktivera',
  'admin.actions.deactivate': 'Inaktivera',
  'admin.websiteEditor.tab.features': 'Funktioner',
  'admin.websiteEditor.tab.testimonials': 'Kundomdömen',
  'admin.websiteEditor.tab.faq': 'FAQ',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'Sidfot',
  'admin.websiteEditor.tab.design': 'Design',
  'admin.websiteEditor.tab.customcode': 'Anpassad kod',
  'admin.websiteEditor.tab.socials': 'Sociala medier',
  'admin.websiteEditor.tab.importexport': 'Importera/exportera',

  // --- AI Settings Editor ---
  'admin.ai.title': 'AI-assistentinställningar',
  'admin.ai.subtitle': 'Konfigurera beteende, stil och analysdjup',
  'admin.ai.smartWeightingActive': 'Smart viktning aktiv',
  'admin.ai.smartWeightingDesc': 'AI kombinerar automatiskt alla perspektiv med smart viktning. Med flera förinställningar vägs den första tyngre (primär förinställning). Du kan också justera viktningen manuellt.',
  'admin.ai.modelTitle': 'IdeaVerdict AI-modell',
  'admin.ai.modelSubtitle': 'Välj AI-motor för alla användaranalyser',
  'admin.ai.activeModel': 'Aktiv modell:',
  'admin.ai.activeModelDesc': 'Alla användare får svar från denna modell.',
  'admin.ai.recommendations': 'Rekommendationer för optimala resultat',
  'admin.ai.new': 'NYTT',
  'admin.ai.recommendationsDesc': 'Beprövade förinställningskombinationer för bästa analyskvalitet',
  'admin.ai.recommendationsInfo': 'Dessa kombinationer har testats och ger de bästa resultaten. Klicka på en rekommendation för att tillämpa den direkt.',
  'admin.ai.active': 'AKTIV',
  'admin.ai.apply': 'Tillämpa',
  'admin.ai.avoid': 'Undvik',
  'admin.ai.excellentQuality': 'Utmärkt kvalitet',
  'admin.ai.goodQuality': 'God kvalitet',
  'admin.ai.poorQuality': 'Utspädd kvalitet - rekommenderas inte',
  'admin.ai.proTips': 'Proffstips',
  'admin.ai.tip1Title': '2 förinställningar är optimalt:',
  'admin.ai.tip1Desc': 'Tydligt perspektiv utan utspädning',
  'admin.ai.tip2Title': 'Primär förinställning spelar roll:',
  'admin.ai.tip2Desc': 'Den första förinställningen har störst inflytande',
  'admin.ai.tip3Title': 'Undvik motsatser:',
  'admin.ai.tip3Desc': '"EXTREME" + "Creative" = motsägelsefullt',
  'admin.ai.tip4Title': 'Max 3 förinställningar:',
  'admin.ai.tip4Desc': 'Med 4+ förinställningar blir resultatet för allmänt',
  'admin.ai.warningManyPresets': 'Varning: Många förinställningar',
  'admin.ai.warningManyPresetsDesc': 'Du har valt {{count}} förinställningar. Detta kan späda ut resultatet.',
  'admin.ai.warningRecommend': 'Rekommenderas: Max 2-3 förinställningar',
  'admin.ai.forOptimalResults': 'för optimala resultat.',
  'admin.ai.presets': 'Förinställningar',
  'admin.ai.multiSelect': '(flerval möjligt)',
  'admin.ai.presetsDesc': 'Välj en eller flera förinställningar. Den första förinställningen är den primära med högst viktning.',
  'admin.ai.primaryPreset': 'Primär förinställning',
  'admin.ai.weightControl': 'Viktkontroll',
  'admin.ai.weightControlDesc': 'Justera hur starkt varje förinställning påverkar analysen',
  'admin.ai.manual': 'Manuell',
  'admin.ai.automatic': 'Automatisk',
  'admin.ai.autoWeightingActive': 'Automatisk viktning aktiv:',
  'admin.ai.autoWeightingDesc': 'Viktningen optimeras automatiskt baserat på antalet förinställningar.',
  'admin.ai.primary': 'PRIMÄR',
  'admin.ai.totalWeight': 'Totalt',
  'admin.ai.shouldBe100': 'bör vara 100%',
  'admin.ai.normalize': 'Normalisera',
  'admin.ai.combinedSettings': 'Kombinerade inställningar',
  'admin.ai.presetsCount': 'förinställningar',
  'admin.ai.strictness': 'Stränghet',
  'admin.ai.realism': 'Realism',
  'admin.ai.creativity': 'Kreativitet',
  'admin.ai.detailLevel': 'Detaljnivå',
  'admin.ai.customInstructions': 'Anpassade instruktioner',
  'admin.ai.customInstructionsDesc': 'Ytterligare instruktioner som kombineras med förinställningarna',
  'admin.ai.customInstructionsPlaceholder': 't.ex. "Fokusera på DACH-marknaden", "Använd alltid konkreta siffror", "Jämför med befintliga konkurrenter", "Svara alltid med exempel"...',
  'admin.ai.customInstructionsHint': 'Dessa instruktioner kombineras automatiskt med de valda förinställningarna.',
  'admin.ai.manualFinetuning': 'Manuell finjustering',
  'admin.ai.manualFinetuningHint': '(valfritt, åsidosätter förinställningsvärden)',
  'admin.ai.manualFinetuningDesc': 'Justera de kombinerade värdena manuellt om du vill finjustera något.',
  'admin.ai.tone': 'Ton',
  'admin.ai.mild': 'Mild',
  'admin.ai.strict': 'Sträng',
  'admin.ai.creative': 'Kreativ',
  'admin.ai.realistic': 'Realistisk',
  'admin.ai.conservative': 'Konservativ',
  'admin.ai.compact': 'Kompakt',
  'admin.ai.detailed': 'Detaljerad',
  'admin.ai.responseLength': 'Svarslängd',
  'admin.ai.short': 'Kort & koncis',
  'admin.ai.medium': 'Medium',
  'admin.ai.long': 'Detaljerad',
  'admin.ai.focusAreas': 'Analysfokusområden',
  'admin.ai.autoRating': 'Automatisk betygsättning',
  'admin.ai.autoRatingDesc': 'Varje analys får automatiskt ett betyg (Bra/Genomsnittlig/Dålig)',
  'admin.ai.showSources': 'Visa källor',
  'admin.ai.showSourcesDesc': 'Referenser till datakällor och marknadsdata i svar',
  'admin.ai.hidePreview': 'Dölj förhandsgranskning',
  'admin.ai.showPreview': 'Visa förhandsgranskning',
  'admin.ai.aiBehavior': 'AI-beteende',
  'admin.ai.length': 'Längd',
  'admin.ai.liveExample': 'Liveexempel',
  'admin.ai.testSettings': 'Testa dina inställningar',
  'admin.ai.selectExampleQuestion': 'Välj exempelfråga:',
  'admin.ai.userAsks': 'Användaren frågar:',
  'admin.ai.generating': 'AI genererar svar...',
  'admin.ai.generateExample': 'Generera exempelsvar',
  'admin.ai.aiResponds': 'AI-assistenten svarar:',
  'admin.ai.generateHint': 'Klicka på "Generera exempelsvar" för att se hur AI svarar med dina inställningar.',
  'admin.ai.reset': 'Återställ',
  'admin.ai.saved': 'Sparad!',
  'admin.ai.saveSettings': 'Spara inställningar',

  // --- Table headers ---
  'admin.coupons.code': 'Kod',
  'admin.coupons.credits': 'Credits',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': 'Balanserad analys med hög kvalitet. Det bästa valet för de flesta nischbedömningar och idévalideringar.',
  'admin.ai.model.preciseAnalyses': 'Exakta analyser',
  'admin.ai.model.bestBalance': 'Bästa balansen',
  'admin.ai.model.recommended': 'Rekommenderas',
  'admin.ai.model.fastDesc': 'Blixtsnabba svar för snabba nischkontroller, brainstorming och initiala bedömningar. Idealisk när hastighet är viktigt.',
  'admin.ai.model.fast': 'SNABB',
  'admin.ai.model.fastestResponses': 'Snabbast svar',
  'admin.ai.model.thinkingDesc': 'Djup analys med avancerat logiskt tänkande. För komplexa marknadsanalyser, kritiska bedömningar och strategisk planering.',
  'admin.ai.model.deepestAnalysis': 'Djupaste analys',
  'admin.ai.model.logicalThinking': 'Logiskt tänkande',
  'admin.ai.model.strategy': 'Strategi',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': 'Sträng analys',
  'admin.ai.preset.strict.desc': 'Kritisk, faktabaserad, inget omsvep. Avslöjar svagheter skoningslöst.',
  'admin.ai.preset.extreme.name': 'EXTREM analys',
  'admin.ai.preset.extreme.desc': 'Maximal stränghet, skoningslös kritik, fokus på värsta fall. Endast för tuffa verklighetskontroller.',
  'admin.ai.preset.professional.name': 'Professionell',
  'admin.ai.preset.professional.desc': 'Objektiv, strukturerad, balanserad. Som en erfaren affärskonsult.',
  'admin.ai.preset.realistic.name': 'Realistisk',
  'admin.ai.preset.realistic.desc': 'Ärlig och praktisk. Fokus på genomförbar implementering och verklig marknadsdata.',
  'admin.ai.preset.creative.name': 'Kreativ & motiverande',
  'admin.ai.preset.creative.desc': 'Inspirerande, idérik, positiv. Hittar möjligheter och okonventionella vägar.',
  'admin.ai.preset.balanced.name': 'Balanserad',
  'admin.ai.preset.balanced.desc': 'Bra blandning av kritik och motivation. Standardläget.',
  'admin.ai.preset.investor.name': 'Investerarperspektiv',
  'admin.ai.preset.investor.desc': 'Som en venturekapitalist. Fokus på skalning, ROI och exitstrategi.',
  'admin.ai.preset.startup-coach.name': 'Startup-coach',
  'admin.ai.preset.startup-coach.desc': 'Praktisk mentor för grundare. Fokus på snabb implementering och MVP.',
  'admin.ai.preset.market-researcher.name': 'Marknadsforskare',
  'admin.ai.preset.market-researcher.desc': 'Datadriven och analytisk. Djup marknads- och konkurrensanalys.',
  'admin.ai.preset.risk-analyst.name': 'Riskanalytiker',
  'admin.ai.preset.risk-analyst.desc': 'Fokus på risker och värsta scenarier. För realistisk planering.',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': 'Marknadsanalys',
  'admin.ai.focus.wettbewerb': 'Konkurrens',
  'admin.ai.focus.monetarisierung': 'Monetarisering',
  'admin.ai.focus.risiken': 'Risker',
  'admin.ai.focus.finanzen': 'Finans',
  'admin.ai.focus.skalierung': 'Skalning',
  'admin.ai.focus.innovation': 'Innovation',
  'admin.ai.focus.trends': 'Trender',
  'admin.ai.focus.differenzierung': 'Differentiering',
  'admin.ai.focus.umsetzung': 'Implementering',
  'admin.ai.focus.zielgruppe': 'Målgrupp',
  'admin.ai.focus.marketing': 'Marknadsföring',

  // --- Tone Options ---
  'admin.ai.tone.direkt': 'Direkt & skoningslös',
  'admin.ai.tone.professionell': 'Professionell & objektiv',
  'admin.ai.tone.ehrlich': 'Ärlig & praktisk',
  'admin.ai.tone.motivierend': 'Motiverande & positiv',
  'admin.ai.tone.freundlich': 'Vänlig & stödjande',
  'admin.ai.tone.akademisch': 'Akademisk & analytisk',

  // --- Example Questions ---
  'admin.ai.question.niche': 'Vilken lönsam nisch rekommenderar du?',
  'admin.ai.question.evaluate': 'Betygsätt min idé: En app för hundägare',
  'admin.ai.question.trends': 'Vilka trender har potential just nu?',
  'admin.ai.question.sharpen': 'Hur kan jag skärpa min nisch?',

  'admin.ai.rec.bestCombination.title': '🏆 Bästa kombinationen (2 förinställningar)',
  'admin.ai.rec.bestCombination.desc': 'Kritisk men konstruktiv, med konkreta åtgärdssteg',
  'admin.ai.rec.bestCombination.useCase': 'Rekommenderas för de flesta analyser',

  'admin.ai.rec.balancedThree.title': '⚖️ Balanserad (3 förinställningar)',
  'admin.ai.rec.balancedThree.desc': 'Professionell, realistisk och investerarvänlig',
  'admin.ai.rec.balancedThree.useCase': 'För omfattande affärsanalyser',

  'admin.ai.rec.creativeDriven.title': '💡 Kreativ & motiverande (2 förinställningar)',
  'admin.ai.rec.creativeDriven.desc': 'Inspirerande med praktiska implementeringstips',
  'admin.ai.rec.creativeDriven.useCase': 'För idégenerering och brainstorming',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Öppna meny',
  'header.home': 'Hem',
  'header.notifications': 'Aviseringar',
  'header.settings': 'Inställningar',
  'header.profile': 'Profil',
  'sidebar.collapse': 'Fäll in sidofältet',
  'sidebar.expand': 'Fäll ut sidofältet',
  'sidebar.close': 'Stäng meny',
  'sidebar.plan': 'Plan',
  'sidebar.backToWebsite': 'Tillbaka till webbplatsen',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'Välkommen tillbaka',
  'overview.greetingSub': 'Det här händer på ditt domsskrivbord.',
  'overview.heroCta': 'Ny dom',
  'overview.currentPlan': 'Aktuellt paket',
  'overview.creditsLabel': 'krediter',
  'overview.usedThisCycle': 'Använda denna cykel',
  'overview.resetsOn': 'Återställs',
  'overview.unlimitedTitle': 'Obegränsat',
  'overview.builderPerk': 'Du har full Builder-åtkomst — inga gränser.',
  'overview.runOne': 'Kör en dom',
  'overview.lastVerdicts': 'Dina senaste 5 domar',
  'overview.noActivity': 'Inga domar än — starta din första analys',
  'overview.tipTitle': 'Tips',
  'overview.tipBody': 'Kör en idé genom två språk — om domen mjuknar i ett, är dina antaganden lokala, inte universella.',
  'onboard.skip': "Hoppa över",
  'onboard.cta.next': "Nästa",
  'onboard.cta.start': "Kom igång",
  'onboard.s1.title': "Välkommen till IdeaVerdict",
  'onboard.s1.body': "En AI-dom över din affärsidé — innan du bygger.",
  'onboard.s2.title': "Brutalt ärliga domar",
  'onboard.s2.body': "Ingen hype, inget smicker. Riktig marknadsdata, riktiga konkurrenter, riktiga risker.",
  'onboard.s3.title': "Builder-rapporter som PDF",
  'onboard.s3.body': "Generera rapporter på 25-75 sidor med full arkitektur, ekonomi och go-to-market-strategi.",
  'onboard.s4.title': "Redo när du är",
  'onboard.s4.body': "Registrera dig och få din första dom på under en minut.",
  'builderReport.title': "Bygger din Builder-rapport",
  'builderReport.subtitle': "Heltäckande analys + utvecklarbriefing — laddas ner som PDF när den är klar.",
  'builderReport.idea': "Din idé",
  'builderReport.ideaPlaceholder': "Beskriv din affärsidé (eller lämna tomt för att använda den senaste idén du diskuterade)…",
  'builderReport.cta': "Generera rapport",
  'builderReport.credits': "krediter",
  'builderReport.deductedNow': "Dras vid lyckad körning",
  'builderReport.dontClose': "Stäng inte detta fönster — generering kan ta 30-90 sekunder.",
  'builderReport.done': "PDF nedladdad — kolla din nedladdningsmapp.",
  'builderReport.failed': "Generering misslyckades",
  'builderReport.close': "Stäng",
  'builderReport.cancel': "Avbryt",
  'builderReport.running': "Genererar…",
  'builderReport.retry': "Försök igen",
  'builderReport.unknownError': "Generering misslyckades. Dina krediter bör återbetalas.",
  'builderReport.signInRequired': "Du måste vara inloggad för att generera en rapport.",
  'builderReport.ideaRequired': "Beskriv din idé så AI:n har något att analysera.",
  'builderReport.fromChat': "Från din nuvarande konversation",
  'builderReport.noIdeaDetected': "Använder idén vi har diskuterat.",
  'builderReport.contextHint': "AI:n använder allt från denna chatt — ingen ny idé hittas på.",
  'builderReport.step.core': "Genererar kärnanalys",
  'builderReport.step.market': "Lägger till utökad marknadsanalys",
  'builderReport.step.tech': "Lägger till teknisk arkitektur",
  'builderReport.step.financials': "Lägger till finansiella modeller",
  'builderReport.step.compet': "Lägger till konkurrensbevakning",
  'builderReport.step.gtm': "Lägger till go-to-market-strategi",
  'builderReport.step.deepdive': "Lägger till branschfördjupning",
  'builderReport.step.pdf': "Kompilerar PDF:en…",
  'briefing.title': "Bygger din Developer Briefing",
  'briefing.subtitle': "11-sektioners teknisk briefing — laddas ner som PDF när den är klar.",
  'briefing.ideaPlaceholder': "Beskriv din affärsidé (eller lämna tomt för att använda den senaste idén du diskuterade)…",
  'briefing.cta': "Generera briefing",
  'briefing.step.core': "Genererar utvecklarbriefing",
  'briefing.step.pdf': "Kompilerar PDF:en…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Fler krediter + 50-sidiga rapporter",
  'pricing.gold.credits': "12 500 krediter per månad",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Högsta nivå + 75-sidiga rapporter",
  'pricing.platinum.credits': "15 000 krediter per månad",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "sv" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Bara {{count}} krediter kvar!",
  'trial.upgradeNow': "Uppgradera nu",
  'trial.upgradeNowArrow': "Uppgradera nu →",
  'trial.creditsExhausted': "Krediter slut",
  'trial.upgradeForUnlimited': "Uppgradera för obegränsad användning",
  'trial.noCreditsPlaceholder': "Inga krediter kvar…",
  'hero.badgeHonest': "Ärlig, opartisk AI",
  'hero.badge60sec': "Dom på 60 sekunder",
  'hero.badge20Lang': "20+ språk",
  'hero.widget.label': "Idédom",
  'hero.widget.passed': "GODKÄND",
  'hero.widget.demoIdea': "AI-handledare för medicinstudenter",
  'hero.widget.market': "Marknad",
  'hero.widget.demand': "Efterfrågan",
  'hero.widget.competition': "Konkurrens",
  'hero.widget.verdictReady': "Dom klar · 47 sek",
  'hero.widget.riskFlagged': "Risk flaggad",
  'hero.widget.crowdedMarket': "Trång marknad · 4 etablerade",
  'hero.widget.suggestedPivot': "Föreslagen pivot",
  'hero.widget.nicheBySpecialty': "Nisch per specialitet",
  'hero.widget.feasibilityGain': "+38% genomförbarhet",
  'hero.widget.analysisDone': "Analys klar",
  'hero.widget.metrics56': "5 av 6 mätvärden",
  'hero.stats.verdictSpeed': "Domens hastighet",
  'cta.badge': "Dom på 60 sekunder",
  'cta.subtitleEnd': "utan gissningar.",
  'cta.signinPrompt': "Har du redan konto? Logga in",
  'cta.trustTrial': "7 dagars gratis testperiod",
  'cta.trustNoCard': "Inget kort krävs",
  'cta.trustCancel': "Avsluta när som helst",
  'footer.themeLabel': "Tema:",
  'footer.lightMode': "Ljust läge",
  'footer.darkMode': "Mörkt läge",
  'footer.sectionProduct': "Produkt",
  'footer.sectionLegal': "Juridiskt",
  'nav.switchLight': "Byt till ljust läge",
  'nav.switchDark': "Byt till mörkt läge",
  'features.badge': "Varför IdeaVerdict",
  'features.mainFeatureLabel': "Rubrik",
  'chatError.planRestriction': "Den här funktionen kräver ett högre abonnemang.",
  'chatError.creditDeduction': "Betalningen misslyckades. Försök igen.",
  'chatError.aiService': "AI-tjänsten är tillfälligt otillgänglig. Dina krediter har inte debiterats. Försök igen.",
  'chatError.parseError': "Oväntat svarsformat mottaget. Försök igen.",
  'chatError.sessionExpired': "Din session har gått ut. Logga in igen.",
  'chatError.timeout': "Begäran tog för lång tid. Försök igen.",
  'chatError.generic': "Det gick inte att få ett svar. Försök igen.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "sv" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "Bara {{count}} krediter kvar!",
  'trial.outOfCredits': "Krediter slut",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Trång marknad · 4 etablerade",
  'hero.widget.nicheBySpec': "Nisch per specialitet",
  'hero.widget.feasibilityUp': "+38% genomförbarhet",
  'hero.widget.fiveOfSix': "5 av 6 mätvärden",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "25-sidig Builder Report",
  'pricing.gold.report': "50-sidig Builder Report",
  'pricing.platinum.report': "75-sidig Builder Report",
  'auth.bestValue': "Bästa värde",
  'auth.elite': "Elit",
  'builderReport.friendlyError': "Vi kunde inte slutföra din rapport den här gången. Dina krediter har inte debiterats — försök igen om en stund.",
  'builderReport.persistHint': "Om problemet kvarstår, kontakta support@ideaverdict.ai.",
};
